module.exports = __webpack_public_path__ + "img/e5c3ff7.png";